import { z } from 'zod'

export const ContributionStatusEnum = {
  ACTIVE: 10,
  INACTIVE: 20,
  DELETED_BENEFIT: 100,
} as const
export const ContributionStatusSchema = z.nativeEnum(ContributionStatusEnum)
export type ContributionStatus = z.infer<typeof ContributionStatusSchema>

export const IntervalEnum = {
  MONTHLY: 10,
  QUARTERLY: 20,
  YEARLY: 30,
} as const
export const IntervalSchema = z.nativeEnum(IntervalEnum)
export type Interval = z.infer<typeof IntervalSchema>

export const IntervalCodeEnum = {
  MONTHLY: 'M',
  QUARTERLY: 'Q',
  YEARLY: 'Y',
} as const
export const IntervalCodeSchema = z.nativeEnum(IntervalCodeEnum)
export type IntervalCode = z.infer<typeof IntervalCodeSchema>
